import styled from 'styled-components';

export const EmptyPageWrapper = styled.div`
    && {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        width: 100%;
    }
`;

export const StyledImage = styled.img`
    && {
        width: 87px;
        height: 87px;
        margin-bottom: 15px;
    }
`;

export const StyledTypography = styled.h2`
    && {
        font-family: 'Alliance No.1';
        font-style: normal;
        font-weight: 700;
        font-size: 2.1875rem;
        line-height: 1.14;
        margin: 0;
        padding: 0;
        text-align: center;
        letter-spacing: -1.5px;
        text-shadow:
            0 0 15px rgb(82 61 241),
            0 0 15px rgb(255 255 255 / 45%);
    }
`;

export const StyledDescription = styled.p`
    max-width: 433px;
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
    text-align: center;
    letter-spacing: -0.05em;
    color: #ffffff;
    opacity: 0.5;
    padding: 0;
    margin: 24px 0 90px 0;
`;

export const AddItemsWrapper = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    justify-content: center;
    grid-row-gap: 25px;
    grid-column-gap: 25px;
`;

export const AddItem = styled.div`
    display: flex;
    flex-direction: column;
    padding: 40px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 30px;
`;

export const AddItemTitle = styled.div`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 1;
    margin-bottom: 10px;
    letter-spacing: -0.05em;
    color: #ffffff;
    margin-bottom: 20px;
`;

export const AddItemDescription = styled.p`
    padding: 0;
    margin: 0 0 25px 0;
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
    letter-spacing: -0.05em;
    color: #ffffff;
    opacity: 0.5;
`;

export const AddItemButtons = styled.div`
    display: flex;
    justify-content: space-between;
    width: 235px;
    margin-top: auto;
    gap: 20px;
`;

export const AddItemSocialButton = styled.button`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    padding: 0;
    margin: 0;
    border-radius: 50%;
    box-shadow:
        0 0 24px #6f28eb,
        inset 0 0 20px rgba(255, 255, 255, 0.3);
    border: 0;
    svg {
        width: 24px;
        height: 24px;
        fill: #fff;
        transition: transform 500ms cubic-bezier(0.33, 1, 0.68, 1);
    }

    &:hover {
        svg {
            transition: transform 300ms cubic-bezier(0.33, 1, 0.68, 1);
            transform: scale(1.2);
        }
    }
`;

export const AddItemSocialButtonTwitter = styled(AddItemSocialButton)`
    background: #1da1f2;
`;

export const AddItemSocialButtonDiscord = styled(AddItemSocialButton)`
    background: #5865f2;
`;

export const AddItemSocialButtonTiktok = styled(AddItemSocialButton)`
    background: #000000;
    /* box-shadow: 0 0 24px #ff0050, inset 0 0 20px rgba(255, 255, 255, 0.3); */
`;
